import React from "react";
import { withStyles } from "@mui/styles";
import { startOfDay, format, parse } from "date-fns";

import SingleLineTextInput from "../../components/singleLineTextInput/SingleLineTextInput";
import DatePickerInput from "../../components/datePickerInput/DatePickerInput";
import TimePickerInput from "../../components/timePickerInput/TimePickerInput";
import Button from "../../components/button/Button";

const isInvalidName = (name) => !name;

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
});

function AddUnavailablePeriodForm({
  classes,
  payload,
  storePayload,
  onSubmit,
  submitting,
}) {
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  const parseTime = (timeStr) => {
    try {
      return parse(timeStr, "HH:mm", new Date());
    } catch {
      return new Date();
    }
  };

  return (
    <div className={classes.section}>
      <DatePickerInput
        label="START DATE"
        value={
          payload.periodStartDate
            ? new Date(payload.periodStartDate)
            : new Date()
        }
        onChange={(value) =>
          storePayload({
            ...payload,
            periodStartDate: startOfDay(new Date(value)).toISOString(),
          })
        }
        showInvalidInput={
          submitAttempted && isInvalidName(payload.periodStartDate)
        }
      />
      <TimePickerInput
        label="START TIME"
        value={
          payload.periodStartTime
            ? parseTime(payload.periodStartTime)
            : new Date()
        }
        onChange={(value) => {
          const start = new Date(value);
          storePayload({
            ...payload,
            periodStartTime: format(start, "HH:mm"),
          });
        }}
        showInvalidInput={false}
      />
      <DatePickerInput
        label="END DATE"
        value={
          payload.periodEndDate ? new Date(payload.periodEndDate) : new Date()
        }
        onChange={(value) =>
          storePayload({
            ...payload,
            periodEndDate: startOfDay(new Date(value)).toISOString(),
          })
        }
        showInvalidInput={
          submitAttempted && isInvalidName(payload.periodEndDate)
        }
      />
      <TimePickerInput
        label="END TIME"
        value={
          payload.periodEndTime ? parseTime(payload.periodEndTime) : new Date()
        }
        onChange={(value) => {
          const end = new Date(value);
          storePayload({
            ...payload,
            periodEndTime: format(end, "HH:mm"),
          });
        }}
        showInvalidInput={false}
      />
      <SingleLineTextInput
        label="REASON"
        value={payload.reason}
        onChange={(value) => storePayload({ ...payload, reason: value })}
        showInvalidInput={submitAttempted && isInvalidName(payload.reason)}
      />
      {onSubmit && (
        <Button
          title="Create"
          onClick={() => {
            setSubmitAttempted(true);
            onSubmit(payload);
          }}
          submitting={submitting}
        />
      )}
    </div>
  );
}

export default withStyles(styles)(AddUnavailablePeriodForm);
